export const enum ContextId {
  Default = 'Default',
  Traffic = 'Traffic',
  PageTargeting = 'PageTargeting',
  CustomReactionScales = 'CustomReactionScales',
  RemoveHotjarBranding = 'RemoveHotjarBranding',
  IncomingFeedback = 'IncomingFeedback',
  UserAttributes = 'UserAttributes',
  PercentageTargeting = 'PercentageTargeting',
  Surveys = 'Surveys',
  SurveyCustomization = 'SurveyCustomization',
  SurveyPerformance = 'SurveyPerformance',
  AskEventsApi = 'AskEventsApi',
  ObserveEventsApi = 'ObserveEventsApi',
  FilterClicked = 'FilterClicked',
  FilterError = 'FilterError',
  FilterIncomingFeedback = 'FilterIncomingFeedback',
  FilterNps = 'FilterNps',
  FilterReferrerUrl = 'FilterReferrerUrl',
  FilterRageClicks = 'FilterRageClicks',
  FilterUTurn = 'FilterUTurn',
  FilterUserAttributes = 'FilterUserAttributes',
  FilterUserSegmentsPlus = 'FilterUserSegmentsPlus',
  FilterUserSegmentsBusiness = 'FilterUserSegmentsBusiness',
  FilterUserSegmentsScale = 'FilterUserSegmentsScale',
  AskAdvancedFilters = 'AskAdvancedFilters',
  ObserveAdvancedFilters = 'ObserveAdvancedFilters',
  ObserveBusinessFilters = 'ObserveBusinessFilters',
  Trends = 'Trends',
  Funnels = 'Funnels',
  GoogleOptimize = 'GoogleOptimize',
  AskSlack = 'AskSlack',
  ObserveSlack = 'ObserveSlack',
  AskZapier = 'AskZapier',
  ObserveZapier = 'ObserveZapier',
  AskMsTeams = 'AskMsTeams',
  ObserveMsTeams = 'ObserveMsTeams',
  Optimizely = 'Optimizely',
  AskWebhooks = 'AskWebhooks',
  ObserveWebhooks = 'ObserveWebhooks',
  AskResponseLimit = 'AskResponseLimit',
  SurveyQuestionImages = 'SurveyQuestionImages',
  ErrorConsole = 'ErrorConsole',
  PublicAPI = 'PublicAPI',
}

export const enum ModalId {
  MultiProduct = 'MultiProduct',
  MultiProductPlanSelect = 'MultiProductPlanSelect',
  MultiProductProductSelect = 'MultiProductProductSelect',
}
